import { getRouteApi } from '@tanstack/react-router';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuPlus } from 'react-icons/lu';

import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';

type Props = {
    onClick: () => void;
};

export const CreateOfferButton: React.FC<Props> = ({ onClick }) => {
    const { t } = useTranslation();
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const disabled = !permissions.commands[AGGREGATE_NAMES.LOAN_REQUEST].recordOffer;

    return (
        <Button
            variant={ButtonVariant.SECONDARY}
            disabled={disabled}
            iconLeft={<LuPlus className="h-4 w-4" />}
            onClick={onClick}
        >
            {t('OFFER_MANAGEMENT.MANUAL_OFFER.BUTTON_TITLE')}
        </Button>
    );
};
